type ApplicationExperienceCodes =
  | 'PO_BOX_INELIGIBLE'
  | 'INVALID_ADDRESS_NO_MATCH_INELIGIBLE'
  | 'BUYER_HASH_FAILED'
  | 'CREDIT_FREEZE'
  | 'AGE_ALABAMA_MILITARY'
  | 'NEEDS_ADDITIONAL_INFORMATION_WARNING'
  | 'CREDIT_DENIAL'
  | 'SANCTIONS_OFAC_DENIAL'
  | 'CAPACITY_RECHECK'
  | 'ALLOY_SYSTEM_OUTAGE';

export const APPLICATION_EXPERIENCE_CODES: Record<
  ApplicationExperienceCodes,
  string[]
> = {
  PO_BOX_INELIGIBLE: ['003'],
  INVALID_ADDRESS_NO_MATCH_INELIGIBLE: ['004'],
  BUYER_HASH_FAILED: ['011'],
  CREDIT_FREEZE: ['005', '006'],
  AGE_ALABAMA_MILITARY: ['002'],
  NEEDS_ADDITIONAL_INFORMATION_WARNING: ['001'],
  CREDIT_DENIAL: ['008', '009'],
  SANCTIONS_OFAC_DENIAL: ['007'],
  CAPACITY_RECHECK: ['010'],
  ALLOY_SYSTEM_OUTAGE: ['014'],
};
